import { Box, Icon, styled, Text } from '@conteg/ui';
import { useTranslation } from 'react-i18next';

const AccessibilityTable = styled.table``;
const AccessibilityTableBody = styled.tbody``;
const AccessibilityTableRow = styled.tr``;
const AccessibilityTableTextCell = styled.td`
  padding: 0.5rem 0;
`;
const AccessibilityTableIconCell = styled.td`
  width: 8rem;
  padding: 0.5rem 0;
`;

type AccessibilityRequirementsProps = {
  easyAccessibleRequested?: boolean;
  easyAccessibleFulfilled?: boolean;
};

const getAccessibilityIcon = (isFulfilled: boolean) => {
  return isFulfilled ? (
    <Icon name="check" color="green" />
  ) : (
    <Icon name="close" color="red" />
  );
};

const AccessibilityRequirements = ({
  easyAccessibleRequested,
  easyAccessibleFulfilled,
}: AccessibilityRequirementsProps) => {
  const { t } = useTranslation();

  return (
    <Box>
      <Text variant="highlight" content={t('Page.Reservation.Accessibility')} />
      <AccessibilityTable>
        <AccessibilityTableBody>
          <AccessibilityTableRow>
            <AccessibilityTableIconCell>
              {getAccessibilityIcon(easyAccessibleRequested ?? false)}
            </AccessibilityTableIconCell>
            <AccessibilityTableTextCell>
              <Text
                variant="large"
                content={
                  easyAccessibleRequested
                    ? t(
                        'Page.Reservation.Accessibility.EasyAccessibleRequested'
                      )
                    : t(
                        'Page.Reservation.Accessibility.EasyAccessibleNotRequested'
                      )
                }
              />
            </AccessibilityTableTextCell>
          </AccessibilityTableRow>
          {easyAccessibleRequested && (
            <AccessibilityTableRow>
              <AccessibilityTableIconCell>
                {getAccessibilityIcon(easyAccessibleFulfilled ?? false)}
              </AccessibilityTableIconCell>
              <AccessibilityTableTextCell>
                <Text
                  variant="large"
                  content={
                    easyAccessibleFulfilled
                      ? t(
                          'Page.Reservation.Accessibility.EasyAccessibleFulfilled'
                        )
                      : t(
                          'Page.Reservation.Accessibility.EasyAccessibleNotFulfilled'
                        )
                  }
                />
              </AccessibilityTableTextCell>
            </AccessibilityTableRow>
          )}
        </AccessibilityTableBody>
      </AccessibilityTable>
    </Box>
  );
};

export default AccessibilityRequirements;
